<template>
  <div class="card">
    <span
      :style="{
        color: titleColor,
        'text-align': 'center',
        'font-weight': 600,
        'font-size': '17px'
      }"
    >
      {{ title }}
    </span>
    <div
      :style="{
        overflowY: model.xAxis
          ? model.xAxis.length > 7
            ? 'auto'
            : 'hidden'
          : model.yAxis.length > 7
          ? 'auto'
          : 'hidden',
        overflowX: model.xAxis
          ? model.xAxis.length > 7
            ? 'auto'
            : 'hidden'
          : model.yAxis.length > 7
          ? 'auto'
          : 'hidden'
      }"
      class="scroll"
    >
      <v-chart
        :key="dynamicMinHeight"
        :option="chartOptions"
        :style="{
          width: '100%',
          minHeight: dynamicMinHeight
        }"
      ></v-chart>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  props: {
    title: String,
    model: Object,
    barType: String
  },
  computed: {
    chartOptions() {
      return {
        grid: {
          top: 20,
          right: 80,
          bottom: 20,
          left: 70
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
            const data = params[0];
            const label = data.name;
            const value = data.value;
            const formattedValue = value
              .toFixed(2)
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            const formattedValueStr =
              this.barType === "economy"
                ? `R$ ${formattedValue}`
                : formattedValue;
            return `${label}: ${formattedValueStr}`;
          }.bind(this)
        },
        xAxis: {
          type: "value",
          scale: true,
          min: 0,
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "category",
          data: this.model.yAxis ? this.model.yAxis : this.model.xAxis,
          scale: true,
          inverse: true,
          axisLabel: {
            rotate: 0,
            color: this.titleColor,
            formatter: value => {
              const parts = value.split(" ");
              if (parts.length > 1) {
                return `${parts[0]}\n${parts.slice(1).join(" ")}`;
              }
              return value;
            },
            overflow: "truncate"
          }
        },
        series: [
          {
            data: this.model.data,
            type: "bar",
            label: {
              show: true,
              color: "white",
              textBorderColor: "#000000",
              textBorderWidth: 2,
              formatter: params => {
                const value = params.value;

                const formattedValue = value
                  .toFixed(2)
                  .replace(".", ",")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                return this.barType === "economy"
                  ? `R$ ${formattedValue}`
                  : formattedValue;
              },
              offset: [30, 5]
            },
            ...(this.barType === "economy" && {
              itemStyle: {
                color: params => {
                  return params.value < 0 ? "#ec5353" : "#34A019";
                }
              }
            })
          }
        ]
      };
    },
    titleColor() {
      return this.$store.state.darkmode ? "white" : "black";
    },
    dynamicMinHeight() {
      const yAxis = this.model.yAxis;
      const xAxis = this.model.xAxis;

      const axisLength =
        yAxis && yAxis.length
          ? yAxis.length
          : xAxis && xAxis.length
          ? xAxis.length
          : 0;

      if (axisLength <= 7) {
        return "100%";
      }

      const baseHeight = 600;
      const extraHeight = 20;
      const extraCategories = axisLength - 25;

      return extraCategories > 0
        ? `${baseHeight + extraCategories * extraHeight}px`
        : `${baseHeight}px`;
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  height: 370px;
  padding: 20px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  margin-bottom: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  border-color: #ffffff;
  border: 1px solid;
  display: flex;
  flex-direction: column;
}

.scroll {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
}
</style>
